module.exports = __webpack_public_path__ + "img/bottomSon.467e9ebf.svg";